import { Genre } from '@novelizing/types';
import './GenreHeader.css';

interface GenreHeaderProps {
  genre: Genre;
}

export const GenreHeader = ({ genre }: GenreHeaderProps) => {
  // Function to handle genre chip click
  // const handleGenreClick = (genreId: number) => {
  // This could be expanded to navigate to the genre page or update state
  //   console.log('Genre clicked:', genreId);
  // };

  // Determine if we have a parent genre to display
  // const hasParent = genre.parent && genre.parent.id;

  return (
    <header className="genre-header">
      <div className="genre-header-content">
        <h1 className="genre-title">{genre.title}</h1>

        {/* <div className="genre-chips">
          
          {hasParent && (
            <span 
              className="genre-chip parent-genre"
              onClick={() => handleGenreClick(genre.parent.id)}
              title="View parent genre"
            >
              
              Parent Genre
              <span className="separator">›</span>
            </span>
          )}
          
          
          <span 
            className="genre-chip current-genre"
            onClick={() => handleGenreClick(genre.id)}
            title="View this genre"
          >
            {genre.title}
          </span>
        </div> */}

        {/* Display genre description if available */}
        {genre.description && (
          <p className="genre-description">{genre.description}</p>
        )}
      </div>
    </header>
  );
};
